module.exports = __webpack_public_path__ + "4528cbdf35a3905a08bbdf3338379419.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-04-10-harrison/diary.jpg
// module id = 615
// module chunks = 0